import { DMAutomationTrigger, OnboardingFlowType } from "@markit/common.types";
import { isReplyDmTrigger, isReplyStoryTrigger } from "@markit/common.utils";

// A list of the onboarding flow options shown on the Customize Experience checklist
export const CUSTOMIZE_EXPERIENCE_GOALS = [
  {
    title: "Grow my list from Instagram",
    url: "/grow-my-list-from-instagram",
    type: OnboardingFlowType.INSTAGRAM_DM,
  },
  {
    title: "Collect contact info & signups",
    url: "/collect-contact-info-and-signups",
    type: OnboardingFlowType.COLLECT_INFO,
  },
  {
    title: "Import existing contacts",
    url: "/import-existing-contacts",
    type: OnboardingFlowType.IMPORT_CONTACTS,
  },
  {
    title: "Host a newsletter or blog",
    url: "/host-a-newsletter-or-blog",
    type: OnboardingFlowType.NEWSLETTER_BLOG,
  },
  {
    title: "Sell digital products",
    url: "/sell-digital-products",
    type: OnboardingFlowType.SELL_PRODUCTS,
  },
  {
    title: "Organize events / sell tickets",
    url: "/organize-events-sell-tickets",
    type: OnboardingFlowType.ORGANIZE_EVENTS,
  },
  {
    title: "Start a paid community",
    url: "/start-a-paid-community",
    type: OnboardingFlowType.PAID_MEMBERSHIP,
  },
  {
    title: "Text from my AI agent or app",
    url: "/text-from-your-ai-agent",
    type: OnboardingFlowType.MCP_API,
  },
];

// Looks up a checklist goal's display title by its flow type
export const getCustomizeExperienceGoalTitle = (
  type: OnboardingFlowType
): string | undefined =>
  CUSTOMIZE_EXPERIENCE_GOALS.find((goal) => goal.type === type)?.title;

// List of total steps for each onboarding flow
export const INSTAGRAM_DM_ONBOARDING_STEPS = 7;
// Reply triggers skip builder tour steps: a story reply has no public replies step, and a DM
// keyword trigger has neither the select content nor the public replies step. Steps after the
// builder (the Create Automation screen) shift down by this many, and the total shrinks.
export const getInstagramDmTourStepsSkipped = (
  trigger?: DMAutomationTrigger
): number => {
  if (!trigger) {
    return 0;
  }
  if (isReplyDmTrigger(trigger)) {
    return 2;
  }
  return isReplyStoryTrigger(trigger) ? 1 : 0;
};
export const getInstagramDmTourTotalSteps = (
  trigger?: DMAutomationTrigger
): number =>
  INSTAGRAM_DM_ONBOARDING_STEPS - getInstagramDmTourStepsSkipped(trigger);

export const COLLECT_INFO_ONBOARDING_STEPS = 4;
export const IMPORT_CONTACTS_ONBOARDING_STEPS = 5;
export const NEWSLETTER_BLOG_ONBOARDING_STEPS = 3;
export const SELL_PRODUCTS_ONBOARDING_STEPS = 6;
export const ORGANIZE_EVENTS_ONBOARDING_STEPS = 5;
export const PROFILE_PICTURE_ONBOARDING_STEPS = 2;
export const MCP_API_ONBOARDING_STEPS = 3;
